import { CalendarIcon, MapPinIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface EventCardProps {
  title: string;
  date: string;
  time: string | null;
  location: string;
  image: string;
  details?: string | null;
}

export default function EventCard({ title, date, time, location, image, details }: EventCardProps) {
  return (
    <Card className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="h-56 bg-gray-200 relative overflow-hidden">
        <img 
          src={image}
          alt={title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#4A1D6E]/70 to-transparent flex items-end">
          <h3 className="text-white font-['Playfair_Display'] text-2xl font-bold p-4">{title}</h3>
        </div>
      </div>
      <CardContent className="p-6">
        <div className="flex items-center mb-4">
          <CalendarIcon className="text-[#D4AF37] mr-2" size={16} />
          <span>{date}{time ? ` at ${time}` : ''}</span>
        </div>
        <div className="flex items-center mb-6">
          <MapPinIcon className="text-[#D4AF37] mr-2" size={16} />
          <span>{location}</span>
        </div>
        {details && (
          <p className="mb-4 text-gray-600">{details}</p>
        )}
        <Button 
          className="inline-block bg-[#4A1D6E] hover:bg-[#7A5195] text-white font-medium py-2 px-4 rounded transition duration-300"
        >
          More Details
        </Button>
      </CardContent>
    </Card>
  );
}
